/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Drastic_Tech_Debug_Logging_PlaceholderInputs */



/**
* | output |
* | --- |
* | "Console logging will appear here to help when debugging" |
*
* @param {Drastic_Tech_Debug_Logging_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const drastic_tech_debug_logging_placeholder = /** @type {((inputs?: Drastic_Tech_Debug_Logging_PlaceholderInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Drastic_Tech_Debug_Logging_PlaceholderInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Les journaux de console apparaitront ici pour aider au debogage")
	if (locale === "de") return /** @type {LocalizedString} */ ("Die Konsolenprotokolle werden hier angezeigt, um beim Debuggen zu helfen.")
	if (locale === "it") return /** @type {LocalizedString} */ ("La registrazione della console apparirà qui per aiutare durante il debug")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Здесь будут отображаться сообщения в консоли, которые помогут при отладке.")
	if (locale === "es") return /** @type {LocalizedString} */ ("El registro de la consola aparecerá aquí para ayudar durante la depuración.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("控制台日志将显示在此处，以帮助调试。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("デバッグ時に役立つコンソールログがここに表示されます")
	if (locale === "hi") return /** @type {LocalizedString} */ ("डीबगिंग में सहायता के लिए कंसोल लॉगिंग यहां दिखाई देगी।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("O registro do console aparecerá aqui para auxiliar na depuração.")
	return /** @type {LocalizedString} */ ("Console logging will appear here to help when debugging")
});